
import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import PrimaryButton from '../../components/button/PrimaryButton';
import { useSelector } from 'react-redux';
import CircularProgress from '../../components/loader/CircularProgress';
import BackButton from '../../components/button/BackButton';
import { useNavigate } from 'react-router-dom';
import { ACCOUNT } from '../../constants/routes';
import { calculateProgress } from '../../utils/userInfoProgress';
import useAxios
 from '../../axios/useAxios';
import { notifyError, notifySuccess } from '../../utils/Notify';
import DeleteAccountModal from '../../components/card/DeleteAccountModal';
import { logout } from '../../actions/userActions';
import PageLoader from '../../components/loader/PageLoader';

const UpdateUserScreen = () => {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const axiosInstance = useAxios();
  const [formData, setFormData] = useState({
    coordonnees: {
      nom: '',
      prenom: '',
      email: '',
    },
    genre: '',
    dateNaissance: '',
    adresse: {
      rue: '',
      ville: '',
      codePostal: '',
    },
    telephone: '',
  });
  //mettre le form datta a plat
  const formDataPlat = {
    nom: formData.coordonnees.nom,
    prenom: formData.coordonnees.prenom,
    email: formData.coordonnees.email,
    gender: formData.genre,
    birthDate: formData.dateNaissance,
    address: formData.adresse.rue,
    city: formData.adresse.ville,
    zipCode: formData.adresse.codePostal,
    phoneNumber: formData.telephone,
  };
  const date = new Date();
  const minimumBirthDate = new Date(
    date.getFullYear() - 18,
    date.getMonth(),
    date.getDate(),
  );
  const [completedSections, setCompletedSections] = useState({
    coordonnees: false,
    genre: false,
    dateNaissance: false,
    adresse: false,
    telephone: false,
  });
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  useEffect(() => {
    const checkCompletedSections = () => {
      setCompletedSections({
        coordonnees:
          formData.coordonnees.nom.length > 1 &&
          formData.coordonnees.prenom.length > 1 &&
          formData.coordonnees.email.match(emailRegex),
        genre: !!formData.genre,
        dateNaissance:
          !!formData.dateNaissance &&
          new Date(formData.dateNaissance) <= minimumBirthDate,
        adresse:
          formData.adresse.rue &&
          formData.adresse.ville &&
          formData.adresse.codePostal,
        telephone: formData.telephone.length >= 10,
      });
    };
    if (user?._id) {
      checkCompletedSections();
    } else {
      console.info('user UpdateUserScreen redirecting to ACCOUNT', user);
      navigate(ACCOUNT);
    }
  }, [formData]);

  const handleChange = (section, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [section]:
        typeof prev[section] === 'object'
          ? { ...prev[section], [field]: value }
          : value,
    }));
  };
  useEffect(() => {
    if (user?._id) {
      console.info('user UpdateUserScreen setting form data', user);
      setFormData({
        coordonnees: {
          nom: user.nom || '',
          prenom: user.prenom || '',
          email: user.email || '',
        },
        genre: user.gender || '',
        dateNaissance: user.birthDate
          ? new Date(user.birthDate).toISOString().split('T')[0]
          : new Date('2003-02-05T00:00:00.000+00:00')
              .toISOString()
              .split('T')[0],
        adresse: {
          rue: user.address || '',
          ville: user.city || '',
          codePostal: user.zipCode || '',
        },
        telephone: user.phoneNumber || '',
      });
    }
  }, [user]);

  const renderPercentageOrCheck = (section, percentage) => {
    const isCompleted = completedSections[section];

    return (
      <div className={`percentage ${isCompleted ? 'as-checkbox' : 'as-text'}`}>
        {isCompleted ? (
          <div className="check-circle">
            <FontAwesomeIcon icon={faCheck} />
          </div>
        ) : (
          `+${percentage}%`
        )}
      </div>
    );
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const response = await axiosInstance.post(
        `/user/updateUser/${user._id}`,
        formDataPlat,
      );
      if (response.status === 200) {
        notifySuccess('Ton compte a été mis à jour avec succès !');
        navigate(ACCOUNT);
      } else {
        notifyError(
          'Une erreur est survenue lors de la mise à jour de ton compte réessaye plus tard😕',
        );
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        notifyError(error?.response?.data?.message);
      }
    }
  };

  const deleteAccount = async (reason_id, reason_label, details) => {
    try {
      const response = await axiosInstance.post(
        `/user/deleteUser/${user._id}`,
        {
          reason_id: reason_id,
          reason_label: reason_label,
          details: details,
        },
      );

      if (response.status === 200) {
        localStorage.removeItem('user');
        logout(navigate, response.status);
        notifySuccess(
          'Ton compte a bien été supprimé! nous espérons te revoir bientôt 😁',
        );

        navigate(ACCOUNT);
      }
    } catch (error) {
      console.error('Error in deleteAccount', error);
      notifyError(
        'Une erreur est survenue lors de la suppression de ton compte réessaye plus tard',
      );
    }
  };

  return user?._id ? (
    <div className="update-user-container">
      <BackButton isAbsolute={true} onClick={() => navigate(ACCOUNT)} />

      <div className="form-header" style={{ '--delay': '0s' }}>
        <h1>Mon compte</h1>
        <CircularProgress
          percentage={calculateProgress(formData)}
          user={user}
        />
      </div>
      <form onSubmit={handleSubmit}>
        {/* Section Coordonnées */}
        <div className="form-section" style={{ '--delay': '0.5s' }}>
          <div className="section-header">
            <div className="section-title">
              <span className="emoji">👤</span>
              <span>Coordonnées</span>
            </div>
            {renderPercentageOrCheck('coordonnees', 30)}
          </div>

          <input
            type="text"
            placeholder="Nom"
            maxLength={30}
            value={formData.coordonnees.nom}
            onChange={(e) => handleChange('coordonnees', 'nom', e.target.value)}
          />

          <input
            type="text"
            maxLength={30}
            placeholder="Prénom"
            value={formData.coordonnees.prenom}
            onChange={(e) =>
              handleChange('coordonnees', 'prenom', e.target.value)
            }
          />

          <input
            type="email"
            placeholder="Email"
            maxLength={30}
            disabled={user.email}
            value={formData.coordonnees.email}
            className={user.email ? 'disabled' : ''}
            onChange={(e) =>
              handleChange('coordonnees', 'email', e.target.value)
            }
          />
        </div>

        {/* Section Genre */}
        <div className="form-section" style={{ '--delay': '1s' }}>
          <div className="section-header">
            <div className="section-title">
              <span className="emoji">🪢</span>
              <span>Genre</span>
            </div>
            {renderPercentageOrCheck('genre', 10)}
          </div>

          <div className="genre-buttons">
            {['Homme', 'Femme', 'Autre'].map((option) => (
              <button
                key={option}
                type="button"
                className={`genre-button ${formData.genre === option ? 'bg-gradient1 active' : ''}`}
                onClick={() => handleChange('genre', '', option)}
              >
                {option}
              </button>
            ))}
          </div>
        </div>

        {/* Section Date de naissance */}
        <div className="form-section" style={{ '--delay': '1.5s' }}>
          <div className="section-header">
            <div className="section-title">
              <span className="emoji">🎂</span>
              <span>Date de naissance</span>
            </div>
            {renderPercentageOrCheck('dateNaissance', 10)}
          </div>

          <input
            type="date"
            max-length={20}
            max={minimumBirthDate.toISOString().split('T')[0]}
            value={formData.dateNaissance}
            onChange={(e) => handleChange('dateNaissance', '', e.target.value)}
          />
        </div>

        {/* Section Adresse */}
        <div className="form-section" style={{ '--delay': '2s' }}>
          <div className="section-header">
            <div className="section-title">
              <span className="emoji">📍</span>
              <span>Adresse postale</span>
            </div>
            {renderPercentageOrCheck('adresse', 20)}
          </div>

          <input
            type="text"
            maxLength={40}
            placeholder="Adresse"
            value={formData.adresse.rue}
            onChange={(e) => handleChange('adresse', 'rue', e.target.value)}
          />

          <input
            type="text"
            maxLength={20}
            placeholder="Ville"
            value={formData.adresse.ville}
            onChange={(e) => handleChange('adresse', 'ville', e.target.value)}
          />

          <input
            type="text"
            maxLength={10}
            placeholder="Code postal"
            value={formData.adresse.codePostal}
            onChange={(e) =>
              handleChange('adresse', 'codePostal', e.target.value)
            }
          />
        </div>

        {/* Section Téléphone */}
        <div className="form-section" style={{ '--delay': '2.5s' }}>
          <div className="section-header">
            <div className="section-title">
              <span className="emoji">📞</span>
              <span>Téléphone</span>
            </div>
            {renderPercentageOrCheck('telephone', 10)}
          </div>

          <input
            type="tel"
            placeholder="Numéro"
            max={12}
            value={user.phoneNumber || formData.telephone}
            disabled={user.phoneNumber}
            className={user.phoneNumber ? 'disabled' : ''}
            onChange={(e) => handleChange('telephone', '', e.target.value)}
          />
        </div>

        {/* Bouton Supprimer */}
        <DeleteAccountModal onConfirm={deleteAccount} />
      </form>

      {/* Bouton Enregistrer fixe */}
      <div className="submit-button-container">
        <PrimaryButton label={'Enregistrer'} onClick={handleSubmit} />
      </div>
    </div>
  ) : (
    <PageLoader />
  );
};

export default UpdateUserScreen;
